import React, { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import { api, rp } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const loadSnap = (url, clientKey) => new Promise((resolve, reject) => {
  if (window.snap) return resolve(window.snap);
  const el = document.createElement("script");
  el.src = url;
  el.setAttribute("data-client-key", clientKey);
  el.onload = () => resolve(window.snap);
  el.onerror = reject;
  document.body.appendChild(el);
});

export const PayOnline = ({ booking, onPaid }) => {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const [enabled, setEnabled] = useState(false);
  React.useEffect(() => {
    api.get("/payments/gateway/config")
      .then((r) => setEnabled(Boolean(r.data.public_enabled)))
      .catch(() => setEnabled(false));
  }, []);
  const due = Math.max(0, (booking.total_payment || 0) - (booking.amount_paid || 0));

  const pay = async () => {
    setBusy(true);
    try {
      const r = await api.post("/public/pay", {
        booking_code: booking.booking_code, whatsapp: booking.customer_whatsapp,
      });
      const snap = await loadSnap(r.data.snap_js_url, r.data.client_key);
      snap.pay(r.data.snap_token, {
        onSuccess: () => { toast.success(t("paidLabel")); onPaid?.(); },
        onPending: () => toast.info(t("paymentPending")),
        onError: () => toast.error(t("paymentFailed")),
        onClose: () => setBusy(false),
      });
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("paymentUnavailable"));
    } finally {
      setBusy(false);
    }
  };

  if (booking.payment_status === "Paid" || due <= 0) return null;
  if (!enabled) return null;
  return (
    <div className="mt-8 rounded-xl border border-black/10 bg-white p-6" data-testid="pay-online-card">
      <div className="flex items-center gap-2 font-semibold"><CreditCard size={16} className="text-lm-red" /> {t("payOnline")}</div>
      <p className="mt-1.5 text-sm text-ink-soft">{t("payOnlineSub")}</p>
      <button data-testid="pay-online-btn" disabled={busy} onClick={pay}
        className="mt-5 h-12 px-7 rounded-full bg-lm-red text-white text-sm hover:bg-ink transition-colors disabled:opacity-50 inline-flex items-center gap-2">
        {busy && <Loader2 size={15} className="animate-spin" />} {rp(due)}
      </button>
    </div>
  );
};
